// contexts/LoaderContext.tsx
import { createContext, useContext, useState, ReactNode } from "react";

interface LoaderContextProps {
	loading: boolean;
	setLoading: (val: boolean) => void;
	loaderMessage: string | null;
	setLoaderMessage: (msg: string | null) => void;
}

const LoaderContext = createContext<LoaderContextProps | undefined>(undefined);

export const useLoader = () => {
	const context = useContext(LoaderContext);
	if (!context) throw new Error("useLoader must be used within LoaderProvider");
	return context;
};

export const LoaderProvider = ({ children }: { children: ReactNode }) => {
	const [loading, setLoading] = useState(false);
	const [loaderMessage, setLoaderMessage] = useState<string | null>(null);

	return (
	<LoaderContext.Provider value={{ loading, setLoading, loaderMessage, setLoaderMessage }}>
		{children}
	</LoaderContext.Provider>
	);
};
